import { API_BASE_URL } from "./apiConfig";
import { SupportTemplate, UserProfileForSupport } from "../types/support";
import { getUserRole } from "./auth";

function buildMailtoAndOpen(
    userProfile: UserProfileForSupport | null,
    template: SupportTemplate | null
): void {
    const fullName =
        userProfile?.displayName ||
        [userProfile?.firstName, userProfile?.lastName].filter(Boolean).join(" ") ||
        "N/A";

    const userEmail = userProfile?.email || localStorage.getItem("userEmail") || "N/A";
    const organizationName = userProfile?.companyName || userProfile?.company || "N/A";
    const role = getUserRole() || "N/A";

    const toEmail = template?.supportEmail || "support@polarisathlete.com";
    const subject = template?.emailSubject || `Support Request - ${organizationName}`;
    const body =
        template?.emailTemplate ||
        `Hello Polaris Support Team,

I am reaching out regarding an issue with my account.

Organization: ${organizationName}
User: ${fullName}
Email: ${userEmail}
Role: ${role}

Issue Description:
[Please describe your issue here]

Thank you for your assistance.

Best regards,
${fullName}`;

    const mailtoLink = `mailto:${encodeURIComponent(toEmail)}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.location.href = mailtoLink;
}

/**
 * Fetch profile + support template and open the user's mail client.
 * Falls back to a hardcoded template on any failure.
 */
export async function openSupportEmail(isAuthenticated: boolean): Promise<void> {
    try {
        const userId = localStorage.getItem("loggedInUserId") || localStorage.getItem("userId");

        if (!userId || !isAuthenticated) {
            buildMailtoAndOpen(null, null);
            return;
        }

        const headers: HeadersInit = {
            Accept: "application/json",
        };

        const profileUrl = `${API_BASE_URL}/api/admins/${encodeURIComponent(userId)}/profile`;
        const profileRes = await fetch(profileUrl, {
            method: "GET",
            headers,
            credentials: "include",
        });

        let userProfile: UserProfileForSupport | null = null;
        if (profileRes.ok) {
            userProfile = await profileRes.json();
        }

        const templateUrl = `${API_BASE_URL}/api/support/template`;
        const templateRes = await fetch(templateUrl, {
            method: "GET",
            headers,
            credentials: "include",
        });

        let template: SupportTemplate | null = null;
        if (templateRes.ok) {
            template = await templateRes.json();
        }

        buildMailtoAndOpen(userProfile, template);
    } catch {
        buildMailtoAndOpen(null, null);
    }
}
